import { AnalyticsTrackingEvent } from '../analytics/events.js';

const buildTrackingParams = ({ trackingParams, mainEntity, }) => {
    var _a;
    const queryParams = Object.assign({}, (trackingParams || {}));
    if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product') {
        queryParams.sku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
        queryParams.stacklineSku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
        queryParams.retailerId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.retailerId;
        queryParams.retailerSku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.retailerSku;
        queryParams.brandId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.brandId;
    }
    else if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand') {
        queryParams.brandId = (_a = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.id) === null || _a === void 0 ? void 0 : _a.toString();
    }
    return queryParams;
};
const trackRetailerProductPageEvent = ({ trackingEventAction, trackingParams, analyticsTrack, }) => {
    var _a;
    if (analyticsTrack) {
        (_a = window === null || window === void 0 ? void 0 : window.dispatchEvent) === null || _a === void 0 ? void 0 : _a.call(window, new CustomEvent('bc-track', {
            bubbles: true,
            detail: Object.assign({ eventName: trackingEventAction }, trackingParams),
        }));
        const eventIndex = ['addToCart', 'openRetailerProductPage', 'navigateToRetailerProductPage'].indexOf(trackingEventAction);
        const eventToPublish = [
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART,
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE,
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE, // use same event for navigateToRetailerProductPage
        ][eventIndex];
        if (eventToPublish) {
            analyticsTrack(eventToPublish, Object.assign({}, trackingParams));
        }
        else {
            console.error(`Event not configured for sending to analytics: ${trackingEventAction}`);
        }
    }
};

export { buildTrackingParams, trackRetailerProductPageEvent };
//# sourceMappingURL=analytics.js.map
